import React from 'react';
import ChangeEntidadPrincipalOrganizacion from './ChangeEntidadPrincipalOrganizacion/ChangeEntidadPrincipalOrganizacion';
import ChangeNombreOrganizacion from './ChangeNombreOrganizacion/ChangeNombreOrganizacion';
import ChangeOrganizacionMiembro from './ChangeOrganizacionMiembro/ChangeOrganizacionMiembro';
import DeleteActividad from './DeleteActividad/DeleteActividad';
import DeleteEntidad from './DeleteEntidad/DeleteEntidad';
import DeleteOrganizacion from './DeleteOrganizacion/DeleteOrganizacion';
import DeleteUser from './DeleteUser/DeleteUser';
import DeleteMiembro from './DeleteMiembro/DeleteMiembro';
import DeleteVoluntario from './DeleteVoluntario/DeleteVoluntario';
import CancelAssociateSubscription from './CancelAssociateSubscription/CancelAssociateSubscription';

const PopupActions = () => {
  return (
    <>
      <DeleteOrganizacion />
      <DeleteEntidad />
      <DeleteUser />
      <ChangeOrganizacionMiembro />
      <DeleteMiembro />
      <ChangeNombreOrganizacion />
      <ChangeEntidadPrincipalOrganizacion />
      <DeleteActividad />
      <DeleteVoluntario />
      <CancelAssociateSubscription />
    </>
  );
};

export default PopupActions;
